import {
  CountryCityLocation,
  IpifyGeoClient,
  getCountry,
  getCountryCity,
} from "@redotech/ipify-client";
import { CachedLocationApiClient } from "./location-api-client";

/**
 * Location client that uses the Ipify external service
 * to get location data based on IP address.
 * Costs money to use so account must be filled.
 * @deprecated Use StorefrontEmbedServerLocationClient instead.
 */
export class IpifyLocationClient extends CachedLocationApiClient {
  constructor(private readonly ipifyGeoClient: IpifyGeoClient) {
    super();
  }

  protected async getCountryUncached(signal: AbortSignal): Promise<string> {
    const response = await getCountry(this.ipifyGeoClient, { signal });
    return response.location.country;
  }

  protected async getDetailedLocationUncached(
    signal: AbortSignal,
  ): Promise<CountryCityLocation> {
    const response = await getCountryCity(this.ipifyGeoClient, { signal });
    return response.location;
  }
}
